import React from 'react'

import { Checkbox, Form } from 'antd'
import identity from 'lodash/identity'
import PT from 'prop-types'

import { getHelp, getValidateStatus } from '../../../utils/forms'

const FormCheckboxGroupInput = props => {
  const { input, label, meta, options, displayMappingFn, normalizeDataFn, additionalStyles } = props
  const { onChange, value } = input

  const antdOptions = displayMappingFn(options)

  const onChangeFn = values => {
    const normalizedData = normalizeDataFn(values)
    onChange(normalizedData)
  }

  const antdValues = displayMappingFn(value ? value : [])

  const labelId = `field-label-${input.name.replace(/[^a-zA-Z0-9]/g, '-')}`

  return (
    <div role="group" aria-labelledby={labelId} style={{ marginBottom: 10, marginLeft: 10 }}>
      <div id={labelId} aria-hidden="true" style={{ fontWeight: 'bold', marginBottom: 10 }}>
        {label}
      </div>
      <Form.Item
        hasFeedback
        help={getHelp(meta)}
        validateStatus={getValidateStatus(meta)}
        style={{
          ...{
            marginBottom: 0,
          },
          ...additionalStyles,
        }}
      />
      <div style={{ fontWeight: 'normal', marginLeft: 15 }}>
        <Checkbox.Group onChange={onChangeFn} value={antdValues}>
          {antdOptions.map(opt => (
            <Checkbox key={opt} value={opt} aria-label={opt}>
              <span aria-hidden="true">{opt}</span>
            </Checkbox>
          ))}
        </Checkbox.Group>
      </div>
    </div>
  )
}

FormCheckboxGroupInput.propTypes = {
  displayMappingFn: PT.func,
  normalizeDataFn: PT.func,
}

FormCheckboxGroupInput.defaultProps = {
  displayMappingFn: identity,
  normalizeDataFn: identity,
}

export default FormCheckboxGroupInput
